module.exports = __webpack_public_path__ + "img/themes.a4b37439.svg";